(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fall-sale-carousel')) {
    customElements.define('fall-sale-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.fall-sale__track');
        this.cards = Array.from(this.querySelectorAll('.fall-sale__card'));
        this.toggle = this.querySelector('[data-toggle]');
        if (!this.track || this.cards.length < 2) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.reduced.matches;
        this.hovering = false;
        this.visible = false;
        this.querySelector('.fall-sale__toolbar').hidden = false;
        const pauseForInteraction = () => { this.playing = false; this.updateToggle(); };
        this.querySelector('[data-prev]').addEventListener('click', () => { pauseForInteraction(); this.move(-1); }, { signal });
        this.querySelector('[data-next]').addEventListener('click', () => { pauseForInteraction(); this.move(1); }, { signal });
        this.toggle.addEventListener('click', () => { this.playing = !this.playing; this.updateToggle(); }, { signal });
        this.track.addEventListener('pointerdown', pauseForInteraction, { signal });
        this.track.addEventListener('wheel', pauseForInteraction, { passive: true, signal });
        this.track.addEventListener('focusin', pauseForInteraction, { signal });
        this.addEventListener('mouseenter', () => { this.hovering = true; }, { signal });
        this.addEventListener('mouseleave', () => { this.hovering = false; }, { signal });
        this.track.addEventListener('scroll', () => {
          const first = this.cards[0].getBoundingClientRect().left;
          const step = this.cards[1].getBoundingClientRect().left - first;
          this.querySelector('[data-current]').textContent = String(Math.round(this.track.scrollLeft / step) + 1);
        }, { passive: true, signal });
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) pauseForInteraction(); }, { signal });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.35 });
        this.observer.observe(this);
        this.timer = setInterval(() => {
          if (this.playing && this.visible && !this.hovering && !document.hidden && !this.contains(document.activeElement)) this.move(1);
        }, Number(this.dataset.interval));
        this.updateToggle();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-pressed', String(this.playing));
        this.toggle.setAttribute('aria-label', this.playing ? this.toggle.dataset.pause : this.toggle.dataset.play);
        this.querySelector('[data-play-icon]').hidden = this.playing;
        this.querySelector('[data-pause-icon]').hidden = !this.playing;
      }
      move(direction) {
        const step = this.cards[1].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left;
        const max = this.track.scrollWidth - this.track.clientWidth;
        let next = this.track.scrollLeft + direction * step;
        if (direction > 0 && this.track.scrollLeft >= max - 3) next = 0;
        if (direction < 0 && this.track.scrollLeft <= 3) next = max;
        this.track.scrollTo({ left: Math.min(max, Math.max(0, next)), behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists-editorial"] && !Shopify.designMode) return;
  try {
    
function initStockistSections(root=document){
  root.querySelectorAll('.stockists-editorial').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const filters=section.querySelector('.se-filters');
    filters.hidden=false;
    const apply=city=>{
      section.querySelectorAll('.se-card').forEach(card=>card.hidden=city!=='all'&&card.dataset.city!==city);
      filters.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.city===city)));
    };
    filters.addEventListener('click',event=>{const button=event.target.closest('button');if(button)apply(button.dataset.city);});
    section.querySelector('[data-show-all]').addEventListener('click',()=>apply('all'));
    section.addEventListener('shopify:block:select',()=>apply('all'));
  });
}
initStockistSections();
document.addEventListener('shopify:section:load',()=>initStockistSections());

  } catch(e) { console.error(e); }
})();
})();
